export default "__VITE_ASSET__C2dPQ69a__"